<template>
  <table class="table-layout">
    <tbody>
      <!-- 第 1 行：公司名称 / 业务员 -->
      <tr>
        <td class="table-cell label-cell">公司名称</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ formData.companyName }}</span>
        </td>
        <td class="table-cell label-cell">业务员</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ formData.salesMan }}</span>
        </td>
      </tr>
      <!-- 第 2 行：申请原因 / 使用设备 -->
      <tr>
        <td class="table-cell label-cell">申请原因</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ formData.applyCause }}</span>
        </td>
        <td class="table-cell label-cell">使用设备及描述</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ formData.useDevice }}</span>
        </td>
      </tr>
      <!-- 申请内容标题 -->
      <tr class="section-row">
        <td class="section-title" colspan="7">
          <i class="el-icon-document section-icon"></i>
          <span>申请内容</span>
        </td>
      </tr>
      <!-- 申请内容表格 -->
      <tr class="content-head-row">
        <td colspan="7" class="content-td-wrapper">
          <el-table
            :data="formData.contentList || []"
            border
            size="small"
            class="content-el-table"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column label="运营商" min-width="100">
              <template slot-scope="scope">
                {{ getOperatorLabel(scope.row.operatorName) }}
              </template>
            </el-table-column>
            <el-table-column label="卡类型" min-width="180">
              <template slot-scope="scope">
                {{ (scope.row.cardList || []).filter(t => !!t).join('，') }}
              </template>
            </el-table-column>
            <el-table-column label="套餐内容(注明配套餐出货或用户充值)/地区" min-width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.packageContent }}
              </template>
            </el-table-column>
            <el-table-column label="数量(PCS)" prop="quantity" min-width="90"></el-table-column>
            <el-table-column label="单价(元)" prop="unitPrice" min-width="90"></el-table-column>
            <el-table-column label="总金额(元)" prop="grossAmount" min-width="100"></el-table-column>
          </el-table>
        </td>
      </tr>
      <!-- 运输方式 / 要求发货日期 -->
      <tr>
        <td class="table-cell label-cell">运输方式</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ transportLabel }}</span>
        </td>
        <td class="table-cell label-cell">要求发货日期</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ formData.deliveryDate }}</span>
        </td>
      </tr>
      <!-- 收货地址 -->
      <tr>
        <td class="table-cell label-cell">收货地址</td>
        <td class="table-cell" colspan="7">
          <span class="cell-text">{{ formData.shippingAddress }}</span>
        </td>
      </tr>
      <!-- 收货人 / 收货人电话 -->
      <tr>
        <td class="table-cell label-cell">收货人</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ formData.consignee }}</span>
        </td>
        <td class="table-cell label-cell">收货人电话</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ formData.receivingPhone }}</span>
        </td>
      </tr>
      <!-- 付款信息 -->
      <tr>
        <td class="table-cell label-cell">是否付款</td>
        <td class="table-cell" colspan="3">
          <div class="pay-block">
            <span class="cell-text pay-status" :class="{ 'pay-yes': formData.whetherToPay == '1', 'pay-no': formData.whetherToPay == '0' }">
              {{ formData.whetherToPay == '1' ? '是' : formData.whetherToPay == '0' ? '否' : '—' }}
            </span>
            <span class="cell-text pay-date-text" v-if="formData.toPayDate">
              <i class="el-icon-date"></i> {{ formData.toPayDate }}
            </span>
          </div>
        </td>
        <td class="table-cell label-cell">付款方式</td>
        <td class="table-cell" colspan="3">
          <span class="cell-text">{{ payModeLabel }}</span>
        </td>
      </tr>
      <!-- 支付凭证 -->
      <tr>
        <td class="table-cell label-cell">支付凭证 / 申请说明</td>
        <td class="table-cell" colspan="7">
          <div class="upload-block">
            <div v-if="payVoucherList.length > 0" class="image-list">
              <el-image
                v-for="(img, idx) in payVoucherList"
                :key="idx"
                class="voucher-image"
                :src="img"
                :preview-src-list="payVoucherList"
                fit="cover">
              </el-image>
            </div>
            <span v-else class="cell-text cell-empty">暂无支付凭证</span>
          </div>
        </td>
      </tr>
      <!-- 备注 -->
      <tr>
        <td class="table-cell label-cell">备注</td>
        <td class="table-cell" colspan="7">
          <span class="cell-text">{{ formData.remark || '—' }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { findShipmentRequestById } from "@/api/api.js";
export default {
  name:'Shipment',
  props: {
    shipmentId: {
      type: [Number,String]
    }
  },
  data() {
    return {
      formData:{},
      domain: process.env.VUE_APP_BASE_URL,
    };
  },
  computed: {
    transportLabel() {
      const map = { '0': '自提', '1': '送货', '2': '快递寄付', '3': '快递到付' };
      return map[this.formData.modeOfTransport] || '—';
    },
    payModeLabel() {
      const map = { '0': '对公转账', '1': '微信', '2': '支付宝', '3': '测试' };
      return map[this.formData.payMode] || '—';
    },
    payVoucherList() {
      if(this.formData.payVoucherList && this.formData.payVoucherList.length > 0){
            let url = this.formData.payVoucherList.map(u => this.domain + u);
            return url;
        } else {
            return [];
      }
    }
  },
  methods: {
    getOperatorLabel(val) {
      const map = { '0': '中国移动', '1': '中国联通', '2': '中国电信', '3': '国际' };
      return map[val] || '—';
    },
    initData() {
      let id = this.shipmentId;
      findShipmentRequestById({id}).then(res => {
        this.formData = res.data.data;
        this.$emit('child-event', {
          value: this.formData.shipmentNo
        });
      });
    },
  },
  created() {
    this.initData();
  },
  watch: {
    shipmentId: {
      handler(val) {
        if (val) {
          this.initData();
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
  @primary: #409EFF;
  @success: #67C23A;
  @danger: #F56C6C;
  @text-primary: #303133;
  @text-regular: #606266;
  @text-secondary: #909399;
  @border-base: #DCDFE6;
  @border-light: #E4E7ED;
  @bg-section: #F5F7FA;

  /* ================= 表格 ================= */
  .table-layout {
    table-layout: auto;
    border-collapse: collapse;
    width: 100%;
    margin: 0;
    td, th {
      text-align: center !important;
      vertical-align: middle !important;
    }
    td {
      border: 1px solid @border-light;
      padding: 10px 12px;
      text-align: left;
      vertical-align: middle;
      font-size: 14px;
      color: @text-primary;
      line-height: 1.5;
    }
    .label-cell {
      background: @bg-section;
      color: @text-regular;
      font-weight: 500;
      text-align: center;
      width: 92px;
      min-width: 92px;
      max-width: 145px;
      white-space: nowrap;
      position: relative;
    }
    .section-row {
      td {
        background: #ECF5FF;
        border-color: #B3D8FF;
      }
    }
    .section-title {
      color: @primary;
      font-weight: 600;
      font-size: 14px;
      padding: 10px 16px;
      .section-icon {
        margin-right: 6px;
        font-size: 15px;
      }
    }
    .content-head-row {
      td {
        transition: background 0.2s;
      }
      &:hover td {
        background: #FAFBFC;
      }
    }
    .content-td-wrapper {
      padding: 8px 16px 16px !important;
    }
    .content-el-table {
      width: 100%;
      border-radius: 4px;
      overflow: hidden;
      /deep/ .el-table__header th {
        background: #f5f7fa;
        color: #606266;
        font-weight: 600;
      }
      /deep/ .el-table__body td {
        text-align: center;
      }
    }
  }

  /* ================= 文本展示 ================= */
  .cell-text {
    color: @text-primary;
    font-size: 14px;
    text-align: center;
    display: block;
    &.cell-empty {
      color: @text-secondary;
    }
  }

  /* ================= 付款块 ================= */
  .pay-block {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .pay-status {
    font-weight: 600;
    &.pay-yes { color: @success; }
    &.pay-no { color: @danger; }
  }
  .pay-date-text {
    color: @text-secondary;
    font-size: 13px;
    i { margin-right: 4px; }
  }

  /* ================= 图片 ================= */
  .upload-block {
    padding: 4px 0;
  }
  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .voucher-image {
    width: 100px;
    height: 100px;
    border-radius: 6px;
    border: 1px solid @border-light;
  }
</style>
